import { BookMarked, Globe, Shield, TriangleAlert, UserCircle } from "lucide-react";
import { Link } from "react-router-dom";

import type { Agente } from "@/hooks/useAdminAgenti";

/**
 * Configurazione dell'agente — SOLA LETTURA in questo giro. La config operativa
 * vive oggi in «Impostazioni M3»; consolidarla qui è un intervento separato.
 */
export function AgenteConfig({ agente }: { agente: Agente }) {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-2.5 rounded-lg border border-amber-200 bg-amber-50 px-3.5 py-3 text-[12.5px] text-amber-900">
        <TriangleAlert className="mt-0.5 size-4 shrink-0" />
        <div>
          <b>Decisione aperta.</b> Oggi questa configurazione vive in «Impostazioni
          M3». La vista qui è in sola lettura: consolidarla nella sezione Agenti è un
          intervento da decidere a parte.
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3.5 md:grid-cols-2">
        <Card titolo="Identità e mittente" Icon={UserCircle}>
          <Riga k="Nome" v={agente.nome} />
          <Riga k="Modulo" v={agente.modulo} />
          <Riga k="Referente umano" v={agente.referente ?? "—"} />
        </Card>

        <Card titolo="Whitelist mittenti" Icon={Shield}>
          <p className="text-[13px] text-muted-foreground">
            Gli indirizzi autorizzati e il comportamento fuori whitelist sono gestiti
            nelle impostazioni del modulo.
          </p>
        </Card>

        <Card titolo="Paesi e regimi" Icon={Globe}>
          <p className="text-[13px] text-muted-foreground">
            La mappa paese → regime doganale e i set di documenti sono gestiti nelle
            impostazioni del modulo.
          </p>
        </Card>

        <Card titolo="Memorie apprese" Icon={BookMarked}>
          <p className="text-[13px] text-muted-foreground">
            Le regole apprese dall'agente (per cliente / paese / globali) sono
            visionabili e disattivabili nelle impostazioni del modulo.
          </p>
        </Card>
      </div>

      <Link
        to="/moduli/spedizioni"
        className="inline-flex items-center text-sm font-semibold text-brand-700 hover:underline"
      >
        Vai a Impostazioni M3 →
      </Link>
    </div>
  );
}

function Card({
  titolo,
  Icon,
  children,
}: {
  titolo: string;
  Icon: React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-xl border bg-card p-4">
      <h4 className="mb-2.5 flex items-center gap-2 text-sm font-bold">
        <Icon className="size-4 text-brand-700" />
        {titolo}
      </h4>
      {children}
    </div>
  );
}

function Riga({ k, v }: { k: string; v: string }) {
  return (
    <div className="flex justify-between border-b py-2 text-[13px] last:border-b-0">
      <span className="text-muted-foreground">{k}</span>
      <span className="font-semibold">{v}</span>
    </div>
  );
}
